/*
 * 政法行业
 */
import React from 'react';
import SkeletonNew from 'components/solution/skeletonNew';
import { headBg, headBgM, challenge, frameSrc, frameSrcM, frame, advantage, scene, caseList } from 'constants/solution/court-solution';

const GovLaw = () => {
  return (
    <SkeletonNew
      headFixed={true}
      challenge={challenge}
      caseList={caseList}
      advantage={advantage}
      scene={scene}
      frame={frame}
      headBg={headBg}
      headBgM={headBgM}
      title="政法行业解决方案"
      simpleDesc="助力智慧政法 加速法治现代化建设"
      desc={`小鱼易连通过构建一体化“智慧政法”全融合云视频平台，促进司法行政效率\n和公共法律服务水平提升，助力执法规范化、管理精细化、服务透明化，推\n进法治现代化建设。`}
      pageTitle="政法行业"
      tdkWord="govLow"
      frameSrc={frameSrc}
      frameSrcM={frameSrcM}
    />
  );
};

export default GovLaw;
